import { createSlice, EntityState } from '@reduxjs/toolkit';
import { jobCardAdapter, jobCarReportAdapter } from './adapter';
import { IJobCardV2 } from '../../types/models/jobCard';
import reducers from './reducer';
import { IJobCardReport } from '~/types/models/jobCardReport';
import { extraReducers } from './extraReducers';
export interface IDictionary {
  label: string;
  value: string;
}

export interface IPagination {
  page: number;
  count: number;
  isMax: boolean;
  all: number;
}

export interface jobCardState {
  jobCardsRunning: EntityState<IJobCardV2> & { loading: boolean; pagination: IPagination };
  jobCardsNotRunning: EntityState<IJobCardV2> & { loading: boolean; pagination: IPagination };
  jobCardsRecently: EntityState<IJobCardV2> & { loading: boolean; pagination: IPagination };
  selectedJobCard: IJobCardV2 | null;
  jobCardReports: EntityState<IJobCardReport> & { loading: boolean };
  loadingTimeReports: boolean;
  showReportSavedModal: boolean;
  isLoadingCreateReport: boolean;
  filter?: Record<string, any>;
  isAddedReportWithEndTime: boolean;
  isNeedAutoStartStop: boolean;
  isSearching: boolean;
}

const pagination: IPagination = {
  page: 1,
  count: 10,
  isMax: false,
  all: 0,
};

const initialState: jobCardState = {
  jobCardsRunning: jobCardAdapter.getInitialState({ loading: false, pagination }),
  jobCardsNotRunning: jobCardAdapter.getInitialState({ loading: false, pagination }),
  jobCardsRecently: jobCardAdapter.getInitialState({ loading: false, pagination }),
  selectedJobCard: null,
  jobCardReports: jobCarReportAdapter.getInitialState({ loading: false }),
  loadingTimeReports: false,
  isLoadingCreateReport: false,
  showReportSavedModal: false,
  isAddedReportWithEndTime: false,
  isNeedAutoStartStop: false,
  isSearching: false,
  filter: {},
};

export const { actions, reducer } = createSlice({
  name: 'jobCard',
  initialState,
  reducers,
  extraReducers,
});

export const {
  toggleLoader,
  selectJobCard,
  setIsSearching,
  setJobCardFilter,
  clearJobCardFilter,
  clearJobCardReports,
  clearSelectedJobCard,
  clearJobCardsRunning,
  clearJobCardsRecently,
  setIsNeedAutoStartStop,
  updateOneJobCardReport,
  updateManyJobCardReport,
  setShowReportSavedModal,
  clearJobCardsNotRunning,
  updateOneReportInJobCard,
  resetShowReportSavedModal,
  resetIsAddedReportWithEndTime,
} = actions;

export default reducer;
